import { Injectable } from '@angular/core';
import { DataService } from './data.service';

@Injectable({
  providedIn: 'root'
})
export class KmzService {
  data:any
  constructor(private dataService: DataService) { }

  getFileUploaderInstance() {

    //refer old app
  };

  saveKmzOrKml(data) {
    return this.dataService.post('/api/KMLLayer/SaveKmlOrKmz', data);
  };

  previewChanges(data) {
    return this.dataService.post('/api/KMLLayer/PreviewChanges', data);
  };
}
